function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.32 23.356a1.095 1.095 0 000 1.549l.775.774a1.095 1.095 0 001.549 0L16 18.323l7.356 7.356a1.095 1.095 0 001.549 0l.774-.774a1.095 1.095 0 000-1.549L18.323 16l7.356-7.356a1.095 1.095 0 000-1.549l-.774-.774a1.095 1.095 0 00-1.549 0L16 13.677 8.644 6.321a1.095 1.095 0 00-1.549 0l-.774.774a1.095 1.095 0 000 1.549L13.677 16l-7.356 7.356z",
  fill: "currentColor"
})));